import * as z from 'zod/v4';

export const wagerIdSchema = z.string().regex(/^\d+$/).brand<'WagerId'>();
export type WagerId = z.infer<typeof wagerIdSchema>;
